export default __webpack_public_path__ + "static/media/White0003.c94a1f44.png";